/**
 * Filen inneholder konstanter fra visningsdefinisjon for næring som benyttes i SME og evt. andre applikasjoner
 * */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    KORTGRUPPER: function() {
        return KORTGRUPPER;
    },
    KORT: function() {
        return KORT;
    },
    DYNAMISK_GRUPPE: function() {
        return DYNAMISK_GRUPPE;
    },
    default: function() {
        return _default;
    }
});
var KORTGRUPPER = {
    OMLOEPSMIDLER_ID: "eiendelerEgenkapitalOgGjeld.kortsiktigeEiendeler.kortgruppe",
    SALGSINNTEKTER_ID: "inntekter.salgsinntekt.kortgruppe",
    SALGS_OG_REPRESENTASJONSKOSTNADER_ID: "kostnader.salgsrepresentasjon.kortgruppe",
    DRIFTS_OG_PRODKOSTNADER_ID: "kostnader.driftsOgProduksjonskostnader.kortgruppe",
    VERKTOEY_OG_INVENTAR_ID: "kostnader.verktoeyOgInventar.kortgruppe",
    VARELAGER_ID: "varelagerOgFordringer.varelager.kortgruppe",
    VAREKOSTNADER_ID: "kostnader.varekostnad.kortgruppe",
    FORDRINGER_KUNDEFORDRINGER_ID: "varelagerOgFordringer.fordringerKundefordringer.kortgruppe",
    BIOLOGISK_EIENDEL_ID: "varelagerOgFordringer.biologiskEiendel.kortgruppe",
    NAERINGSKJOERETOEY_ID: "driftsmidler.naeringskjoeretoey.kortgruppe",
    SALDOAVSKRIVING_ID: "driftsmidler.saldoavskriving.kortgruppe",
    LINEAER_AVSKRIVING_ID: "driftsmidler.lineaerAvskriving.kortgruppe",
    IKKE_AVSKRIVBARE_ANLEGGSMIDLER_ID: "driftsmidler.ikkeAvskrivbareAnleggsmidler.kortgruppe",
    GEVINST_OG_TAPSKONTO_ID: "driftsmidler.gevinstOgTapskonto.kortgruppe",
    LOENNSKOSTNADER_ID: "kostnader.loennskostnad.kortgruppe",
    ANDRE_DRIFTSKOSTNADER_ID: "kostnader.andreDriftskostnader.kortgruppe",
    BEREGNET_PERSONINNTEKT: "beregnetPersoninntekt.fordeltBeregnetPersoninntekt.kortgruppe",
    BEREGNET_NAERINGSINNTEKT: "beregnetNaeringsinntekt.fordeltBeregnetNaeringsinntekt.kortgruppe"
};
var KORT = {
    SALGSINNTEKT_REF: "salgsinntekt"
};
var DYNAMISK_GRUPPE = {
    INNTEKT_REF: "inntekt",
    KOSTNAD_REF: "kostnad",
    BALANSEVERDI_REF: "balanseverdi",
    KAPITAL_REF: "kapital",
    GJELD_REF: "gjeld"
};
var _default = {
    KORTGRUPPER: KORTGRUPPER,
    KORT: KORT,
    DYNAMISK_GRUPPE: DYNAMISK_GRUPPE
};
